package br.com.texeratx.boardgametimeapp.ui.screens.players.detail

import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI

data class PlayerDetailUIModel(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val nickname: String?,
    val birthday: String?,
    val phone: String?,
    val clanId: Long,
    val gamesOwned: List<PlayerOwnedGameUI>,
    val recentMatches: List<MatchListItemUI>,
    val winsByGame: List<PlayerGameWinUI>,
    val stats: PlayerDetailStatsUI,
    val matchupStats: PlayerMatchupStatsUI?
)

data class PlayerOwnedGameUI(
    val id: Long,
    val name: String,
    val imageUrl: String?
)

data class PlayerDetailStatsUI(
    val wins: Int,
    val participations: Int,
    val minutesPlayed: Int,
    val winsCurrentYear: Int,
    val participationsCurrentYear: Int,
    val minutesPlayedCurrentYear: Int
)

data class PlayerGameWinUI(
    val gameId: Long,
    val gameName: String,
    val gameImageUrl: String?,
    val wins: Int
)

data class PlayerMatchupStatsUI(
    val total: MatchupPeriodUI,
    val currentYear: MatchupPeriodUI
)

data class MatchupPeriodUI(
    val highlights: MatchupHighlightsUI,
    val topRivals: List<RivalMatchupUI>
)

data class MatchupHighlightsUI(
    val mostDefeated: RivalMatchupUI?,
    val mostLostTo: RivalMatchupUI?,
    val mostPlayedTogether: RivalMatchupUI?
)

data class RivalMatchupUI(
    val opponentId: Long,
    val opponentName: String,
    val opponentNickname: String?,
    val opponentImageUrl: String?,
    val matchesTogether: Int,
    val wins: Int,
    val losses: Int,
    val winRatePct: Int,
    val dominance: Int,
    val lastMatchDate: String?,
    val bestGameAgainst: MatchupGameSummaryUI?,
    val worstGameAgainst: MatchupGameSummaryUI?
)

data class MatchupGameSummaryUI(
    val gameId: Long,
    val gameName: String,
    val gameImageUrl: String?,
    val wins: Int,
    val losses: Int
)
